import { forwardRef } from 'react';
import './ProductGridSkeleton.scss';

/** Matches MOB_PRODUCTS_PAGE_SIZE default first page for mobile grid. */
const DEFAULT_CELLS = 10;

/**
 * Placeholder grid matching product card layout (2 columns, image + meta).
 * Use while the real list is deferred or fetching — does not remove image decode,
 * but avoids an empty jump and sets expectations during load.
 */
export const ProductGridSkeleton = forwardRef(function ProductGridSkeleton(
    { cells = DEFAULT_CELLS, className = '', layoutGridClass = '' },
    ref
) {
    const rootClass = ['product-grid-skeleton', layoutGridClass, className].filter(Boolean).join(' ');

    return (
        <div ref={ref} className={rootClass} aria-busy="true" aria-label="Loading products">
            {Array.from({ length: cells }, (_, i) => (
                <div key={i} className="product-grid-skeleton__card">
                    <div className="product-grid-skeleton__media" />
                    <div className="product-grid-skeleton__meta">
                        <div className="product-grid-skeleton__line product-grid-skeleton__line--brand" />
                        <div className="product-grid-skeleton__line product-grid-skeleton__line--title" />
                        <div className="product-grid-skeleton__line product-grid-skeleton__line--price" />
                    </div>
                </div>
            ))}
        </div>
    );
});
